import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiErrorLogClientSideErrorMutationRequest,
  PostApiErrorLogClientSideErrorMutationResponse,
  PostApiErrorLogClientSideError401,
  PostApiErrorLogClientSideError403,
} from "../../../types/PostApiErrorLogClientSideError";

export function getPostApiErrorLogClientSideErrorUrl() {
  return `/api/Error/log-client-side-error` as const;
}

/**
 * {@link /api/Error/log-client-side-error}
 */
export async function postApiErrorLogClientSideError(
  data?: PostApiErrorLogClientSideErrorMutationRequest,
  config: Partial<
    RequestConfig<PostApiErrorLogClientSideErrorMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiErrorLogClientSideErrorMutationResponse,
    ResponseErrorConfig<
      PostApiErrorLogClientSideError401 | PostApiErrorLogClientSideError403
    >,
    PostApiErrorLogClientSideErrorMutationRequest
  >({
    method: "POST",
    url: getPostApiErrorLogClientSideErrorUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
